export default __webpack_public_path__ + "static/media/Single_Arrow_Icon.9f48c8b9.svg";